import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceEmployee } from '@qaroni-app/absences/types/absence-employee';
import { AbsenceUnitEnum } from '@qaroni-app/absences/types/absence-unit.enum';

@Component({
  selector: 'qaroni-absence-employee-summary',
  templateUrl: './absence-employee-summary.component.html',
  styleUrl: './absence-employee-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceEmployeeSummaryComponent {
  readonly absenceEmployee = input<AbsenceEmployee | null>(null);

  get duration(): string {
    const timeAbsence = this.absenceEmployee()?.timeAbsence?.[0];
    if (!timeAbsence) {
      return '';
    }

    if (timeAbsence.unit === AbsenceUnitEnum.HOURS) {
      const mins = Number(timeAbsence.time);
      const hours = Math.floor(mins / 60);
      const remainingMins = mins % 60;
      return `${hours}h ${remainingMins > 0 ? remainingMins + 'min' : ''}`;
    }
    return $localize`${timeAbsence.time} día(s)`;
  }
}
